module.exports = __webpack_public_path__ + "img/toast_logo.1aac2b2f.png";